<template>
    <FontAwesomeIcon
        v-bind="$attrs"
        v-bind:icon="name"
    />
</template>

<script>
    import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
    import { library } from '@fortawesome/fontawesome-svg-core';

    import {
        faSearch as fasSearch,
        faTimes as fasTimes,
        faBars as fasBars,
        faDownload as fasDownload,
    } from '@fortawesome/free-solid-svg-icons';

    import {
        faSearch as falSearch,
        faTimes as falTimes,
        faTimesCircle as falTimesCircle,
        faCircle as falCircle,
    } from '@fortawesome/pro-light-svg-icons';

    import {
        faSearch as farSearch,
        faCamera as farCamera,
        faPlay as farPlay,
        faCode as farCode,
        faGripLines as farGripLines,
    } from '@fortawesome/pro-regular-svg-icons';

    // https://fontawesome.com/icons
    library.add(
        falSearch,
        farSearch,
        fasSearch,
        falTimes,
        fasTimes,
        fasBars,
        fasDownload,
        falTimesCircle,
        farCamera,
        falCircle,
        farPlay,
        farCode,
        farGripLines,
    );

    export default {
        /**
         * Determine how unrecognized component properties should be handled by the Vue compiler.
         *
         * @link https://vuejs.org/v2/api/#inheritAttrs
         *
         * @type {Boolean}
         */
        inheritAttrs: false,

        /**
         * Declaratively register required components.
         *
         * @link https://vuejs.org/v2/guide/components.html#Local-Registration
         */
        components: {
            FontAwesomeIcon,
        },

        /**
         * Define the properties passed into the component from the parent.
         *
         * @link https://vuejs.org/v2/guide/components.html#Props
         */
        props: {
            name: {
                type: [
                    String,
                    Array,
                ],
                required: true,
            },
        },
    };
</script>
